import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import { Table } from 'antd';
import moment from 'moment';

import QuestionsReviewView from '../../components/fpp/QuestionsReviewView';
import ConnectedFileManageContainer from '../file/FileManageContainer';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';

class FPPAssessmentViewContainer extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      getFPPMainQuestions: PropTypes.func.isRequired,
      getRecommendation: PropTypes.func.isRequired,
    }).isRequired,
    assessmentId: PropTypes.string.isRequired, // userSurveyId
  };

  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      answers: [],
      phase: 1,
      startFromEnd: false,
      recommendation: {
        modifedAt: null,
        risk: null,
        recommendation: null,
        totalScore: null,
      },
    };
  }

  componentDidMount() {
    const {
      actions: {
        getSubmittedSurveyDetail,
      },
      assessmentId,
    } = this.props;

    this.q = getSubmittedSurveyDetail(assessmentId)
      .then((response) => {
        const { answerDetails: questions } = response;

        const newAnswers = [];
        questions.forEach((qEl, i) => {
          newAnswers[i] = {
            questionType: qEl.question.questionType,
            selectedAnswers: [],
            selectedRows: [],
            answerOfQuestion: i,
          };
          qEl.answers.forEach((ansEl, j) => {
            qEl.selectedAnswers.forEach((sAnsEl) => {
              if (sAnsEl.surveyQuestionAnswerId === ansEl.id) {
                newAnswers[i].selectedAnswers.push(ansEl);
                newAnswers[i].selectedRows.push(j);
              }
            });
          });
        });

        this.setState({
          questions,
          answers: newAnswers,
          recommendation: response,
        });
      });
  }

  render() {
    const {
      answers,
      questions: completeQuestions,
      recommendation: {
        modifiedAt: timestamp,
        totalScore,
        risk,
        recommendation,
      },
    } = this.state;
    const summaryRow = [
      {
        title: 'Date',
        width: 400,
        dataIndex: 'timestamp',
      },
      {
        title: 'Total Score',
        dataIndex: 'totalScore',
      },
    ];
    const infoRow = [
      {
        key: 0,
        timestamp: moment(timestamp).format('YYYY-MM-DD hh:mm:ss A'),
        totalScore,
      },
    ];
    const riskRow = [
      {
        title: 'Risk',
        width: 400,
        dataIndex: 'risk',
      },
      {
        title: 'Recommendation',
        dataIndex: 'text',
      },
    ];
    const recommendationRow = [
      {
        key: 0,
        risk,
        text: recommendation,
      },
    ];
    return (
      <div>
        <div>
          <ConnectedFileManageContainer {...this.props} />
          <br />
        </div>
        <div>
          <Table
            bordered
            columns={riskRow}
            size="middle"
            dataSource={recommendationRow}
            pagination={false}
          />
          <br />
          <Table
            bordered
            columns={summaryRow}
            dataSource={infoRow}
            size="middle"
            pagination={false}
          />
        </div >
        {completeQuestions.length ? (() => (
          <div>
            <QuestionsReviewView
              questionSet={completeQuestions}
              nextPhase={() => { }}
              previousPhase={() => { }}
              resumeAnswerSet={answers}
              disableNavButtons
              showConfirmMessage={false}
            />
            <br />
          </div>
        ))() : null}
      </div>
    );
  }
}

export default connectActionsAndReducers(FPPAssessmentViewContainer);



// WEBPACK FOOTER //
// ./src/containers/fpp/FPPAssessmentViewContainer.js